module.exports = __webpack_public_path__ + "img/image-01.cbe75858.webp";